import { render, staticRenderFns } from "./BuildingSelector.vue?vue&type=template&id=3379d046"
import script from "./BuildingSelector.vue?vue&type=script&lang=js"
export * from "./BuildingSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports